import React from 'react';
import PageLayout from '../Layouts/PageLayout';

const PrivacyPolicy = () => {
  return (
    <PageLayout title="Privacy Policy">
      <div className="container mx-auto px-[35px] md:px-[60px] lg:px-[100px] text-[#444444]">
        <h1 className="text-[#B12929] font-bold text-3xl md:text-4xl mb-2 border-b-2 border-gray-200 pb-4">
          Privacy Policy
        </h1>
        <p className="mb-8 text-[16px] text-gray-500 italic">Virat India Micro Finance</p>

        <div className="space-y-8 text-[17px] leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">1. Introduction</h2>
            <p>
              Virat India Micro Finance ("we," "us," or "our") is committed to protecting the privacy
              and security of personal information collected from clients, visitors, and other
              stakeholders. This Privacy Policy explains how we collect, use, disclose, and safeguard
              your personal information when you interact with our website or services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-[#2c2c2c]">2. Information We Collect</h2>
            <p className="mb-3">We may collect the following types of personal information:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Name, email address, phone number, and business details provided through contact forms, service requests, or consultations.</li>
              <li>Payment information (such as transaction details) for service fees.</li>
              <li>Usage data, including IP address, browser type, and website activity, for analytics and service improvement.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-[#2c2c2c]">3. How We Use Your Information</h2>
            <p className="mb-3">We use your personal information for the following purposes:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>To provide, manage, and improve our consulting services.</li>
              <li>To respond to inquiries, process service requests, and communicate with clients.</li>
              <li>To comply with legal and regulatory requirements.</li>
              <li>To analyze website usage and enhance user experience.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-[#2c2c2c]">4. Data Sharing and Disclosure</h2>
            <p className="mb-3">
              We do not sell or rent your personal information to third parties. We may share your
              information with:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Service providers who assist in delivering our services (e.g., payment processors, IT support).</li>
              <li>Legal or regulatory authorities, if required by law.</li>
            </ul>
            <p className="mt-3">
              All third parties are bound by confidentiality agreements and data protection obligations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">5. Data Security</h2>
            <p>
              We implement reasonable security measures to protect your personal information from
              unauthorized access, disclosure, alteration, or destruction. This includes technical,
              administrative, and physical safeguards.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">6. Data Retention</h2>
            <p>
              We retain your personal information only for as long as necessary to fulfill the purposes
              outlined in this policy or as required by law. After this period, your data will be
              securely deleted or anonymized.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-[#2c2c2c]">7. Your Rights</h2>
            <p className="mb-3">You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access, correct, or delete your personal information.</li>
              <li>Withdraw consent for data processing (where applicable).</li>
              <li>Lodge a complaint with the Data Protection Board of India if you believe your rights have been violated.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">8. Cookies and Tracking Technologies</h2>
            <p>
              Our website may use cookies and similar technologies to enhance user experience and
              analyze website traffic. You can manage your cookie preferences through your browser
              settings.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically to reflect changes in our practices or
              legal requirements. The latest version will be posted on our website with the effective
              date.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">10. Contact Us</h2>
            <p className="mb-3">
              For any questions or concerns regarding this Privacy Policy or your personal information,
              please contact us at:
            </p>
            <ul className="space-y-1">
              <li>
                <span className="font-medium">Email: </span>
                <a href="mailto:viratindia2023@gmail.com" className="text-[#B12929] hover:underline">
                 viratindia2023@gmail.com
                </a>
              </li>
              <li>
                <span className="font-medium">Address: </span>
                 <span className="text-gray-500">Mahuawa, Pakri Tola P.O-Mahuawa Buzurg, Kusinagar, U.P – 274302</span>
              </li>
            </ul>
          </section>

        </div>
      </div>
    </PageLayout>
  );
};

export default PrivacyPolicy;
